import _ from "lodash";

export const mapCardTypeToIcon = (cardType?: string): string[] => {
  switch (_.toLower(cardType)) {
    case "americanexpress":
      return ["fab", "cc-amex"];
    case "visa":
      return ["fab", "cc-visa"];
    case "mastercard":
      return ["fab", "cc-mastercard"];
    case "dinersclub":
      return ["fab", "cc-diners-club"];
    case "discover":
      return ["fab", "cc-discover"];
    case "jcb":
      return ["fab", "cc-jcb"];
    default:
      return ["far", "credit-card"];
  }
};
